import { Injectable } from "@angular/core";
import { LocalUser } from "@core/interfaces/entities";

@Injectable({
    providedIn: "root",
})
export class LocalUserService {
    private userData: LocalUser = null;

    recordUserData(userData: LocalUser) {
        this.userData = userData;
    }

    get getUserData(): LocalUser {
        return this.userData;
    }
}
